import { render, staticRenderFns } from "./BusinessUnitDetails.vue?vue&type=template&id=db11e29c&"
import script from "./BusinessUnitDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports